import { useTheme } from '@mui/material'
import React from 'react'
import { RiskIcon } from 'src/designSystem/icons'
import { AssessmentTrend, RiskLevel } from 'src/graphql.generated'
import IndicatorChip from './IndicatorChip'

type Props = {
  level: RiskLevel
  trend: AssessmentTrend
  expanded?: boolean
}

const RiskIndicator = ({ level, trend, expanded = false }: Props) => {
  const { palette } = useTheme()
  const levelColor: Record<RiskLevel, string> = {
    [RiskLevel.Low]: palette.severityLow,
    [RiskLevel.Medium]: palette.severityMedium,
    [RiskLevel.High]: palette.severityHigh,
  }
  const trendLabel: Record<AssessmentTrend, string> = {
    [AssessmentTrend.Increased]: 'Risk increased',
    [AssessmentTrend.Decreased]: 'Risk decreased',
    [AssessmentTrend.Stable]: 'Risk',
  }

  return (
    <IndicatorChip
      tooltip={trendLabel[trend]}
      label={expanded ? 'Risk' : undefined}
      color={levelColor[level]}
      testId="risk-indicator"
    >
      <RiskIcon trend={trend} />
    </IndicatorChip>
  )
}

export default RiskIndicator
